import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/all.min.css';

// Chrome can surface ResizeObserver as an error event; it is usually benign when third-party
// code observes layout in the same frame as a resize. Match broadly so dev overlay stays quiet.
function isResizeObserverLoopMessage(message) {
  return typeof message === 'string' && message.includes('ResizeObserver loop');
}

// capture: true runs before CRA/react-error-overlay listeners on the same target (bubble phase).
window.addEventListener(
  'error',
  (event) => {
    const msg = event?.message || event?.error?.message || '';
    if (isResizeObserverLoopMessage(msg)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener(
  'unhandledrejection',
  (event) => {
    const reason = event?.reason;
    const msg = typeof reason === 'string' ? reason : reason?.message || '';
    if (isResizeObserverLoopMessage(msg)) {
      event.preventDefault();
    }
  },
  true
);


ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
